import React from "react";
import Rules from "../../../../../config/rules";
import DateInput from "./DateInput";
import { ValidatorForm } from "react-material-ui-form-validator";
import StringHelper from "../../../../../helpers/StringHelper";


const SSDateInput = (props) => {

    React.useEffect(()=> {
        ValidatorForm.addValidationRule('isValidNumDateNaiss', isValidNumDateNaiss)
        ValidatorForm.addValidationRule('isBeforeNow', Rules.isValidDate)
        return () => {
            ValidatorForm.removeValidationRule('isValidNumDateNaiss');
            ValidatorForm.removeValidationRule('isBeforeNow');
        }
    }, [props.ss])

    const {
        ss,
        ...rest
    } = props;


    const isValidNumDateNaiss = (value) => {
        const unformatedSS = StringHelper.unformatSSNum(props.ss);
        return props.ss === '' ? true : Rules.isValidNumDateNaiss(value, unformatedSS);
    }


    return (
        <DateInput
            label = "Date de naissance*"
            validators={['required', 'isBeforeNow' , 'isValidNumDateNaiss']}
            errorMessages={[Rules.txtRequis,  Rules.txtDateIsBeforeNow, Rules.txtMustBeLikeNumSS]}
            canBeBefore1950={true}
            {...rest}
        />
    )
}

export default SSDateInput;